import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// GET ALL 
export const GetAllInitial = createAsyncThunk(
  "masters/initial/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Masters.Country_Initial}?name=${filter?.name || ""}&country_id=${filter?.country_id || ""
        }&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



//GET SINGLE
export const GetInitial = createAsyncThunk(
  "masters/initial/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Masters.Country_Initial}/${id}`);
      return res;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



//CREATE
export const AddInitial = createAsyncThunk(
  "masters/initial/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Masters.Country_Initial, data);
      return res;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// UPDATE
export const UpdateInitial = createAsyncThunk(
  "masters/initial/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Masters.Country_Initial}/${id}`,
        data   // send FormData 
      );
      return res;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//DELETE 
export const DeleteInitial = createAsyncThunk(
  "masters/initial/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Masters.Country_Initial}/${id}`);
      return id;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


// STATUS
export const StatusInitial = createAsyncThunk(
  "masters/initial/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Masters.Country_Initial}/${id}`);
      return res;
    }
    catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "initial",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder

      // GET ALL 
      .addCase(GetAllInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllInitial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //GET SINGLE
      .addCase(GetInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetInitial.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //CREATE 
      .addCase(AddInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddInitial.fulfilled, (state) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        //state.data.unshift(action.payload?.data);
      })
      .addCase(AddInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //UPDATE
      .addCase(UpdateInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(UpdateInitial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex(
          (item) => item.id === updated?.id
        );

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(UpdateInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //DELETE
      .addCase(DeleteInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteInitial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter(
          (item) => item.id !== action.payload
        );
      })
      .addCase(DeleteInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //STATUS
      .addCase(StatusInitial.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusInitial.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;

        const updated = action.payload?.data;

        const index = state.data.findIndex(
          (item) => item.id === updated?.id
        );

        if (index !== -1) {
          state.data[index] = updated;
        }
      })
      .addCase(StatusInitial.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

export default Slice.reducer;
